import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { setSessionStorageItem } from '@grandvisionhq/utils';
import { authorize } from '../auth.js';

function useSocialLoginFlow() {
    const { href  } = useLink({
        route: 'auth.callback'
    }) || {};
    const initializeSocialLoginFlow = React.useCallback((provider, returnPath)=>{
        if (!href) return;
        const redirectUri = new URL(href, window.location.origin);
        redirectUri.searchParams.append('loginMethod', 'social');
        if (returnPath) {
            setSessionStorageItem('login_returnPath', returnPath);
        }
        authorize({
            connection: 'google-oauth2',
            responseType: 'token id_token',
            redirectUri: redirectUri.toString()
        });
    }, [
        href
    ]);
    return {
        initializeSocialLoginFlow
    };
}

export { useSocialLoginFlow };
//# sourceMappingURL=use-social-login-flow.js.map
